import { common } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse"
import APIService from "../../helper/api-service";
import { IMessage } from "../../models/common/IChatBot";
import { apiConfig } from "../../constants/apiConfig";
import { urlBinder } from "../../helper/url-binder";
import axios from "axios";

export default new (class chatBotService {
  // public sendChatBotMessage = async (data: IMessage): Promise<IApiResponse<boolean | any>> => {
  //   try {
  //     let endPoint = common.SEND_CHATBOT_MESSAGE;
  //     const response = await APIService.post(endPoint, data);
  //     console.log("responseData in Service", response.data.data);
  //     return response.data as IApiResponse<boolean | any>;
  //   } catch (error: any) {
  //     if (error.response) {
  //       return error.response as IApiResponse<boolean | any>;
  //     } else {
  //       throw error;
  //     }
  //   }
  // };

  // public studentAgent = async (data: IMessage): Promise<IApiResponse<boolean | any>> => {
  //   try {
  //     let endPoint = common.SEND_STUDENT_MESSAGE;
  //     const response = await APIService.post(endPoint, data);
  //     console.log("responseData in Service", response.data.data);
  //     return response.data as IApiResponse<boolean | any>;
  //   } catch (error: any) {
  //     if (error.response) {
  //       return error.response as IApiResponse<boolean | any>;
  //     } else {
  //       throw error;
  //     }
  //   }
  // };

  public aiChatAgentService = async (data: IMessage): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = common.SUPER_AGENT;
      const response = await APIService.post(endPoint, data);
      console.log("responseData in Service", response.data.data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

})();

